import { Input, Form as FormAnt, Modal, Upload, message, Switch, Row, Col } from 'antd';

import { sdk } from '../../../../../../API/TT_ELD/mobile/sdk';

const { TextArea } = Input;

type MyObjectType = {
  [key: string | number]: any;
};

const BluetoothEdit = ({
  isModalVisible,
  setIsModalVisible,
  refetchData,
  getOneData,
}: {
  isModalVisible: boolean | undefined;
  setIsModalVisible(isModalVisible: boolean): void;
  refetchData: any;
  getOneData: any;
}) => {
  const [form] = FormAnt.useForm();
  const normFile = (e: any) => (Array.isArray(e) ? e : e?.fileList);

  const beforeUpload = (file: File) => {
    const isBin = file.name.toLowerCase().endsWith('.bin');
    if (!isBin) {
      message.error('You can only upload .BIN files!');
    }

    const isLt200M = file.size / 1024 / 1024 < 200;
    if (!isLt200M) {
      message.error('File must be smaller than 200MB!');
    }

    return isBin && isLt200M ? false : Upload.LIST_IGNORE;
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const body: MyObjectType = {};

      for (const key in values) {
        const currentVal = getOneData[key];
        const newVal = values[key];

        if (typeof currentVal === 'object' && !Array.isArray(currentVal) && currentVal != null) {
          for (const nestedKey in newVal) {
            if (currentVal[nestedKey] !== newVal[nestedKey]) {
              body[key] = newVal;
              break;
            }
          }
        } else if (currentVal !== newVal) {
          body[key] = newVal;
        }
      }

      await sdk.updateSDK(body, getOneData?.id);
      setIsModalVisible(false);
      refetchData();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal title="Bluetooth Edit" onOk={handleOk} open={isModalVisible} onCancel={handleCancel}>
      <br />
      {
        <FormAnt
          form={form}
          name="basic"
          layout="vertical"
          wrapperCol={{ span: 16 }}
          initialValues={getOneData}
          autoComplete="off"
        >
          <FormAnt.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter the name!',
              },
              {
                validator: async (_, value) => {
                  if (value && value.trim() === '') {
                    throw new Error('Name cannot be empty!');
                  }
                },
              },
            ]}
          >
            <Input placeholder="Enter name" />
          </FormAnt.Item>

          <FormAnt.Item label="Note" name="note">
            <TextArea rows={4} />
          </FormAnt.Item>

          <Row gutter={16}>
            <Col span={12}>
              <FormAnt.Item label="Active" name="is_active" valuePropName="checked">
                <Switch />
              </FormAnt.Item>
            </Col>

            <Col span={12}>
              <FormAnt.Item label="Supported" name="is_supported" valuePropName="checked">
                <Switch />
              </FormAnt.Item>
            </Col>
          </Row>
        </FormAnt>
      }
    </Modal>
  );
};

export default BluetoothEdit;
